import ReleaseUpdater from "@/ReleaseUpdater";
let r=new ReleaseUpdater();
window.$releaseUpdater=r;